import { createModalHook } from '../../hooks/useModal'

export const useChangePaymentMethodModal = createModalHook()
